import React from 'react';
import {
    Outlet
} from 'react-router-dom';
import {
    AiLabProvider
} from 'builders/builderInternal/context/AiLabContext';

const AiLabWrapper = () => {
    return (
        <AiLabProvider>
            <Outlet />
        </AiLabProvider>
    );
};

export default AiLabWrapper;